import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { HiMenuAlt1 } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap'
import { Nav, Navbar, Dropdown, Container, Image } from 'react-bootstrap'
import { admin_logout } from '../../redux/actions/adminAuthActions'
import { user_logout } from '../../redux/actions/userAuthActions'
import { get_current_campaign_user } from '../../redux/actions/campaignActions'
// import '../assets/styles/navbar.css'
import logo from '../../assets/FEEMFUNDY-LOGO-4.png'
import logo_black from '../../assets/FEEMFUNDY-LOGO-1.png'

const Header = ({ loc }) => {
	const dispatch = useDispatch()

	const userAuth = useSelector((state) => state.userAuth)
	const { userDetail } = userAuth

	const adminAuth = useSelector((state) => state.adminAuth)
	const { detail } = adminAuth

	const getCurrentCampaign = useSelector((state) => state.getCurrentCampaign)
	const { currentCampaign } = getCurrentCampaign

	const logoutHandler = (e) => {
		e.preventDefault()
		dispatch(user_logout())
	}

	const adminLogoutHandler = (e) => {
		e.preventDefault()
		dispatch(admin_logout())
	}

	useEffect(() => {
		dispatch(get_current_campaign_user())
	}, [dispatch])

	return (
		<header>
			<Navbar
				className={
					loc == '/home'
						? 'home_nav home_nav1 fixed-top'
						: 'home_nav home_nav2 fixed-top'
				}
				expand='lg'
				collapseOnSelect
			>
				<Container>
					<LinkContainer to='/'>
						<Link to='/home'>
							<Image
								src={loc == '/home' ? logo : logo_black}
								alt='logo'
								className='logo'
							/>
						</Link>
					</LinkContainer>
					<Navbar.Toggle aria-controls='basic-navbar-nav'>
						<HiMenuAlt1 />
					</Navbar.Toggle>
					<Navbar.Collapse id='basic-navbar-nav'>
						<Nav className='ml-auto'>
							<LinkContainer to='/about-us'>
								<Nav.Link className='js-scroll'> About </Nav.Link>
							</LinkContainer>
							<LinkContainer to='/projects'>
								<Nav.Link className='js-scroll'> Projects </Nav.Link>
							</LinkContainer>
							<LinkContainer to='/professionals'>
								<Nav.Link className='js-scroll'> Professionals </Nav.Link>
							</LinkContainer>
							{/* <LinkContainer to='/contact'>
								<Nav.Link className='js-scroll'> Contact </Nav.Link>
							</LinkContainer> */}
							<LinkContainer to='#'>
								<Dropdown className='js-scroll'>
									<Dropdown.Toggle
										variant=''
										className='js-scroll2 pt-2 camp_btn'
										id='dropdown-basic'
									>
										Campaigns
									</Dropdown.Toggle>

									<Dropdown.Menu>
										{/* <Dropdown.Item to='/campaign/1'>AloFund</Dropdown.Item> */}
										{currentCampaign &&
											currentCampaign.map((e) => (
												<LinkContainer to={`/campaign/${e.name}`}>
													<Nav.Link className=''> {e.name} </Nav.Link>
												</LinkContainer>
											))}
									</Dropdown.Menu>
								</Dropdown>
							</LinkContainer>

							{userDetail ? (
								<LinkContainer to='#'>
									<Dropdown className='js-scroll'>
										<Dropdown.Toggle
											variant=''
											className='js-scroll2 pt-2 camp_btn'
											id='dropdown-basic'
										>
											{userDetail && (
												<span>Hello, {userDetail.firstName} </span>
											)}
										</Dropdown.Toggle>

										<Dropdown.Menu>
											<LinkContainer to='/user/dashboard/home'>
												<Nav.Link className=''> My Dashboard </Nav.Link>
											</LinkContainer>
											<LinkContainer to='#' onClick={logoutHandler}>
												<Nav.Link className=''> Sign Out </Nav.Link>
											</LinkContainer>
										</Dropdown.Menu>
									</Dropdown>
								</LinkContainer>
							) : detail ? (
								<LinkContainer to='#'>
									<Dropdown className='js-scroll'>
										<Dropdown.Toggle
											variant=''
											className='js-scroll2 pt-2 camp_btn'
											id='dropdown-basic'
										>
											{detail && <span>Hello, {detail.name} </span>}
										</Dropdown.Toggle>

										<Dropdown.Menu>
											<LinkContainer to='/admin/dashboard/home'>
												<Nav.Link className=''> My Dashboard </Nav.Link>
											</LinkContainer>
											<LinkContainer to='#' onClick={adminLogoutHandler}>
												<Nav.Link className=''> Sign Out </Nav.Link>
											</LinkContainer>
										</Dropdown.Menu>
									</Dropdown>
								</LinkContainer>
							) : (
								<>
									<LinkContainer to='/login' className='js-scroll'>
										<Nav.Link> Login </Nav.Link>
									</LinkContainer>
									<LinkContainer
										to='/register'
										className=''
										style={{ fontSize: '14px' }}
									>
										<Nav.Link className='nav_btn text-white'>Register</Nav.Link>
									</LinkContainer>
								</>
							)}
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</header>
	)
}

export default Header
